import React from "react"
import {graphql, useStaticQuery} from "gatsby";

const ContactBox = ({pageContext, product = 'Signature'}) => {
    const lang = pageContext.locale.path.default;
    const query = useStaticQuery(graphql`
    query {
        contact: markdownRemark (
            frontmatter: {
                name: { eq: "contact-box" }
            }
        ) {
            frontmatter {
                en {
                    title
                    list_1
                    list_2
                    list_3
                    call
                    schedule
               }
                es {
                    
                    title
                    list_1
                    list_2
                    list_3
                    call
                    schedule
               }
            }
        }
    }`);
    const contact = query.contact.frontmatter[lang];
    const title = (typeof String.prototype.replaceAll !== "undefined") ? contact.title.replaceAll('_product_', product) : contact.title;

    let image = 'avatar.jpg';

    if (product === 'Identity') {
        image = 'avatar1.jpg';
    } else if (product === 'Dxbot'){
        image = 'avatar2.jpg';
    }

    return (
        <div className="accordion contact-box" id="accordionExample" data-aos="fade-up" data-aos-delay="2000">
            <div className="card border card-contact">
                <div className="card-header" id="headingOne">
                    <h2 className="mb-0">
                        <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne">
                            <div className="media">
                                <img src={require('../../img/' + image).default} className="mr-5 rounded-circle img-contact" alt="..." width="42"/>
                                <div className="media-body">
                                    <p className="spacing font-contact">{title}</p>
                                </div>
                            </div>
                        </button>
                    </h2>
                </div>

                <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <hr className="hr-text4" data-content=""/>
                    <div className="card-body">
                        <ul className="list-contact">
                            <li>
                                <span className="font-contact-1 spacing">
                                    <i className="fe fe-chevron-right icon-land text-tecalis"/> {contact.list_1}
                                </span>
                            </li>
                            <li>
                                <span className="font-contact-1 spacing">
                                    <i className="fe fe-chevron-right icon-land text-tecalis"/> {contact.list_2}
                                </span>
                            </li>
                            <li>
                                <span className="font-contact-1 spacing">
                                    <i className="fe fe-chevron-right icon-land text-tecalis"/> {contact.list_3}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div style={{position: 'relative', top: '-40px'}}>
                        <h6 align="center" className="text-uppercase mb-1">
                            {contact.call}
                        </h6>
                        <div align="center" className="mb-1">
                            <i className="fe fe-phone icon-land text-tecalis"/> <a href="tel:+34911011700" className="color-tecalis font-weight-black">+34 91 10 11 700*</a>
                        </div>
                        <h6 align="center" className="ext-gray-700 mb-1">
                            {contact.schedule}
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactBox
